import React, { useEffect, useState, useCallback } from 'react';
import api from '@/lib/api';
import { PageHeader } from '@/components/app/PageHeader';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Building2, MapPin, Search } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PROPERTY_TYPE_LABEL } from '@/lib/constants';

export default function AgentProperties() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState('');
  const load = useCallback(() => api.get('/properties', { params: { q: q || undefined } }).then((r) => setItems(r.data)), [q]);
  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <PageHeader title="My Properties" subtitle="View assigned properties. Add visit / lead notes from each property." />
      <div className="mb-4 max-w-md">
        <div className="relative">
          <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input className="pl-8" placeholder="Search by name, city, address" value={q} onChange={(e) => setQ(e.target.value)} data-testid="agent-properties-search" />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {items.length === 0 && (
          <div className="col-span-full text-sm text-center text-muted-foreground py-12">No properties assigned to you yet.</div>
        )}
        {items.map((p) => (
          <Link key={p.id} to={`/agent/properties/${p.id}`} className="block" data-testid={`agent-prop-card-${p.id}`}>
            <Card className="overflow-hidden card-hover h-full">
              <div className="h-32 bg-muted">
                {p.image_url ? <img src={p.image_url} alt="" className="h-full w-full object-cover" /> : <div className="h-full grid place-items-center text-muted-foreground"><Building2 className="h-8 w-8" /></div>}
              </div>
              <div className="p-4 space-y-1">
                <div className="flex items-start justify-between gap-2">
                  <div className="font-semibold">{p.name}</div>
                  <Badge variant="outline" className="capitalize text-[10px]">{PROPERTY_TYPE_LABEL[p.type] || p.type}</Badge>
                </div>
                <div className="text-xs text-muted-foreground font-mono">{p.code}</div>
                <div className="text-xs text-muted-foreground flex items-start gap-1"><MapPin className="h-3.5 w-3.5 mt-0.5" /> <span className="line-clamp-2">{p.address}</span></div>
                <div className="text-xs text-muted-foreground pt-1 border-t mt-2">Units: <span className="font-medium text-foreground">{p.total_units}</span></div>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
